import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

/**
 * Class to retrive vehicle Types Dropdown
 */
class VehicleTypesDD extends React.Component {
  componentDidMount() {
    this.props.dispatch({
      types: [
        `GET_VEHICLE_TYPES_PENDING`,
        `GET_VEHICLE_TYPES_FULFILLED`,
        `GET_VEHICLE_TYPES_REJECTED`,
      ],
      method: "GET",
      url: "user/v1/auth/vendor/vehicle/types",
      returnExistObject: "vehicleTypes",
      // queryParams: {
      //   filter: { where: { active: true }, order: "sortOrder ASC" },
      // },
    });
  }

  render() {
    const {
      vehicleTypes: {
        response: { data: vehicleTypes },
      },
      allOption,
      dispatch,
      ...rest
    } = this.props;
    return (
      <select {...rest}>
        <option value=""> -- Select -- </option>
        {allOption && <option value="0"> All </option>}
        {vehicleTypes &&
          vehicleTypes.length &&
          vehicleTypes.map((type, index) => (
            <option value={type.id} key={index}>
              {type.name}
            </option>
          ))}
      </select>
    );
  }
}
VehicleTypesDD.propTypes = {
  vehicleTypes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  allOption: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default connect((state) => {
  return {
    vehicleTypes: state.vehicleTypes,
  };
})(VehicleTypesDD);
